export default __webpack_public_path__ + "static/media/eym_fr.12da9f01.svg";